import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileBottomNav from './MobileBottomNav';
import { useAuth } from '../context/AuthContext';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  // Don't show layout for certain pages
  const hideLayout = ['/call'].some(path => location.pathname.startsWith(path));

  // Hide mobile bottom nav on specific pages (like forms)
  const hideMobileNav = ['/vehicles/new', '/vehicles/edit'].some(path =>
    location.pathname.startsWith(path)
  );

  if (hideLayout) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 lg:hidden ${sidebarOpen ? '' : 'hidden'}`}>
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} />
        <div className="relative flex h-full w-64 flex-col bg-white shadow-xl">
          <Sidebar onClose={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-30 lg:flex lg:w-64 lg:flex-col">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="lg:pl-64">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main
          className="py-6 md:pb-6"
          style={{
            paddingBottom: user?.username === 'admin' || user?.isOwner || hideMobileNav
              ? '1.5rem'
              : 'calc(var(--footer-h, 96px) + 1rem)'
          }}
        >
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>

        {/* Mobile Bottom Navigation - Hidden on form pages */}
        {!hideMobileNav && <MobileBottomNav />}
      </div>
    </div>
  );
};

export default Layout;